import styled from "styled-components";

export const Styles = styled.div<{ $isMobile?: boolean }>`
  .container-side_bar_company {
    height: calc(100vh - 55px);
    width: ${(props) => (props.$isMobile ? "55px" : "68px")};
    background: #192a4d;
    display: flex;
    flex-direction: column;
    touch-action: none !important;
    direction: rtl;

    .my-page-button-wrapper {
      display: flex;
      justify-content: center;
      width: 100%;
      margin-top: 6px;
    }

    .my-page-button {
      height: 44px;
      width: 44px;
      border-radius: 4px;
      background-color: #9ca3af;
      color: #fff;
      border: 1px solid #fff;
      font-size: 8px;
      padding: 0px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 2px;
    }

    > * {
      direction: ltr;
    }
  }

  .companies-list-scrollable {
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
    min-height: 0;
    direction: rtl;
    scrollbar-width: none;
    -ms-overflow-style: none;

    > * {
      direction: ltr;
    }

    &::-webkit-scrollbar {
      display: none;
    }

    &::-webkit-scrollbar-track {
      background: #c8c8c8;
    }
  }
  .container-img_logo {
    user-select: none;
    &:hover {
      border-color: #fff !important;
    }
  }
  .ant-spin-dot-item {
    background-color: #fff !important;
  }
  .ant-spin-nested-loading {
    position: fixed;
    top: 48px;
    left: 0px;
  }
  .ant-spin-blur {
    height: calc(100vh - 48px);
  }
`;

interface SearchButtonContainerProps {
  $isActive: boolean;
  $isMobile?: boolean;
}

export const SearchButtonWrapper = styled.div<{ $isMobile?: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 40px;
  background: #192a4d;
  flex-shrink: 0;
  box-sizing: border-box;
`;

export const SearchButtonContainer = styled.div<SearchButtonContainerProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 44px;
  height: ${(props) => (props.$isMobile ? "20px" : "26px")} !important;
  border-radius: 4px;
  cursor: pointer;
  user-select: none;
  padding: 0;
  box-shadow: ${(props) =>
    props.$isActive ? "0 0 0 2px #1E90FF" : "0 0 0 2px transparent"};
  transition: box-shadow 0.2s ease;

  &:hover {
    box-shadow: ${(props) =>
      props.$isActive ? "0 0 0 2px #1E90FF" : "0 0 0 2px #fff"};
  }
`;

export const SearchIconWrapper = styled.div<SearchButtonContainerProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0;
  width: 44px;
  height: ${(props) => (props.$isMobile ? "20px" : "26px")};
  border-radius: 4px;
  border: 1px solid #fff;
  background-color: #192a4d;
`;

export const WrapperSideBarCompany = styled.div<{ $isMobile?: boolean }>`
  position: fixed;
  top: 48px;
  z-index: 100;
  ${(props) => (props.$isMobile ? "bottom: 0;" : "height: calc(100vh - 48px);")}
  width: ${(props) => (props.$isMobile ? "55px" : "68px")};
  padding-top: 8px;
  padding-bottom: 16px;
  background: #192a4d;
`;

export const StyledSpinWrapper = styled.div`
  width: 100%;
  height: 100%;
  max-height: 85vh;
`;

export const SearchText = styled.span<{ $isMobile?: boolean }>`
  line-height: 1;
  font-weight: 700;
  color: #ffffff;
  border-radius: 4px;
  width: 44px;
  padding: 4px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  font-size: 14px;

  ${(props) =>
    props.$isMobile &&
    `
    background-color: transparent;
    border: 1px solid #ffffff;
    border-radius: 4px;
    color: #ffffff;
    font-size: 12px;
    font-weight: 400;
    height: 20px;
  `}
`;

interface SortableItemWrapperProps {
  $transform?: string;
  $transition?: string;
  $isDragging: boolean;
}

export const SortableItemWrapper = styled.div<SortableItemWrapperProps>`
  transform: ${(props) => props.$transform || "none"};
  transition: ${(props) => props.$transition || "none"};
  width: 100%;
  margin-bottom: 5px;
  display: flex;
  justify-content: center;
  cursor: ${(props) => (props.$isDragging ? "grabbing" : "grab")};
`;
